import axios from 'axios';
import { combineReducers } from 'redux';
import i18next from 'i18next';
import _ from 'lodash';

import { USER_FETCH_WITHHOLDING_REPORT } from 'src/constants/EndpointUrls';
import { setGlobalErrors } from 'src/reducers/global';
import createNamedWrapperReducer from 'src/reducers/createNamedWrapperReducer';
import { listReducer, itemReducer } from 'src/reducers/common';
import { setItem, setLoading } from 'src/reducers/common/itemReducer';

export const REDUCER_NAME = 'userWithholdingReport';

export const fetchUserWithholdingReport = year => async dispatch => {
  try {
    dispatch(setLoading(REDUCER_NAME, true));
    const params = { year };
    const response = await axios.get(USER_FETCH_WITHHOLDING_REPORT, { params });
    const employee = _.get(response, 'data.payload.employee', {});
    dispatch(setItem(REDUCER_NAME, { ...employee, ...(employee ? { year } : {}) }));
  } catch (_error) {
    const errorMessage = [i18next.t('reducers.users.an_error_occurred_while_retrieving_report'), i18next.t('reducers.users.please_try_to_reload_this_page')];
    dispatch(setGlobalErrors(errorMessage));
  } finally {
    dispatch(setLoading(REDUCER_NAME, false));
  }
};

export default combineReducers({
  list: createNamedWrapperReducer(listReducer, REDUCER_NAME),
  item: createNamedWrapperReducer(itemReducer, REDUCER_NAME)
});
